import { render, staticRenderFns } from "./TheBuildingEditForm.vue?vue&type=template&id=a33c5a18&"
import script from "./TheBuildingEditForm.vue?vue&type=script&lang=js&"
export * from "./TheBuildingEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports